import { LANGUAGE_LABELS, SupportedLanguage, i18n } from "i18n/i18n";
import {
  createAppSelector,
  selectCurrentSection,
  selectCurrentUserRole,
  selectSectionCapabilities,
} from "store/selectors";
import { INSTRUCTOR_FORUM_USER_GUIDE_URL, STUDENT_FORUM_USER_GUIDE_URL } from "utils/urls";

export const selectBaseSystemPrompt = createAppSelector(
  [selectCurrentUserRole, selectCurrentSection, selectSectionCapabilities],
  (userRole, section, sectionCapabilities) => {
    const isStudent = sectionCapabilities.canParticipateInSection;
    const sectionLanguage = section?.section_language || "unspecified";
    const sectionLanguageDiffersFromUserLanguage =
      sectionLanguage !== "unspecified" && sectionLanguage !== i18n.language;
    const userGuideUrl = isStudent ? STUDENT_FORUM_USER_GUIDE_URL : INSTRUCTOR_FORUM_USER_GUIDE_URL;
    // TODO: Are we currently linked to an LMS?
    // TODO: Which organization are we in?
    return [
      "You're Minerva's AI assistant, designed to help instructors and students navigate and interact with Forum.",
      "You don't describe yourself unless asked.",
      "Forum is an end-to-end technology solution for Higher Ed institutions that helps create, teach,",
      "and assess educational content, and track student progress, with a focus on skills-focused,",
      "evidence-based pedagogy, outcomes-driven assessment, and active learning.",
      "Individual sections in Forum can be linked to an institution's LMS, and once linked, will sync data between the two.",
      "You may quote titles of Pages or Outcomes, but do not quote IDs, which are for internal use only.",
      `The user you're interacting with speaks ${LANGUAGE_LABELS[i18n.language as SupportedLanguage]},`,
      sectionLanguageDiffersFromUserLanguage
        ? `The section is in ${LANGUAGE_LABELS[sectionLanguage]}. You should only assess in the section language, but can respond to the user's questions in the section language or the language they spoke to you in, whichever seems most appropriate.`
        : "You should respond in that language unless specifically directed otherwise.",
      `You are interacting with a user in the role of ${userRole}.`,
      `If users have questions about the use of Forum, you can refer them to "${userGuideUrl}" using markdown links at your discretion.`,
      // TODO: We could support this - just need to handle the response data and upload to S3, etc.
      // but probably not worth it for now.
      `You cannot generate images or video. Do not generate images or video.`,
    ].join("\n");
  },
);
